import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  // ReloadOutlined,
  // ArrowUpOutlined,
  // ArrowDownOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import {
  getUserMappingAndUsers,
  updateWorkspace,
  getUserOnboarding,
  updateSkill,
} from '../skills_action';
import { getWorkspaceDashboardChartData } from './dashboardMetrics';
import {
  getWorkspaceActivityLog,
  getWorkspaceCkecInActivies,
  getWorkspaceJiraNotificationsLog,
  getWorkspaceActiveUsers,
} from './dashboardMetrics';
import {
  Card,
  Row,
  Col,
  message,
  Statistic,
  Typography,
  Button,
  Progress,
  Modal,
} from 'antd';
import DashboardChart from './charts';
import moment from 'moment';
import CreateTeamsyncModal from '../troopr_standup/createTeamsyncModal';
import Welcome_to_troopr_card_svg from '../../../media/Home Tab/welcome_to_troopr_card.svg';
import HelpdeskIcon from '../../../media/Home Tab/Helpdesk.svg';
import WikiIcon from '../../../media/Home Tab/Wiki.svg';
import ProjectIcon from '../../../media/Home Tab/Projects.svg';
import ReportIcon from '../../../media/Home Tab/reports.svg';
import CheckinIcon from '../../../media/Home Tab/Checkins.svg';
import ActiveUsersIcon from '../../../media/Home Tab/Active users.svg';
import ChannelsWithTrooprIcon from '../../../media/Home Tab/Channels with Troopr.svg';
import VerifedJiraAccountIcon from '../../../media/Home Tab/Verified Jira account.svg';
import WorkflowActivitieIcon from '../../../media/Home Tab/Workflow activities.svg';
import CheckCircleIcon from '../../../media/Home Tab/check-circle.svg';

const { Title, Text } = Typography;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jiraSkill: false,
      toggleNewStandupModal: false,
      isJiraConnected: false,
      wId: '',
      globalRefresh: this.props.refresh,
      // ---- metrics ----

      // ---- User Activity
      // UserActivityThisMonth: 0,
      // UserActivityLastMonth: 0,
      // UserActivityProgress: 0,
      UserActivityLastupdated: null,
      // UserActivityLoading: false,
      channelsWithTroopr: 0,
      workflowActivities: 0,

      // ---- check in submissions
      // CheckInSubmissionsThisMonth: 0,
      // CheckInSubmissionsLastMonth: 0,
      // CheckInSubmissionsLastupdated: null,
      // CheckInSubmissionsLoading: false,
      // activeCheckinsCount: 0,

      // --- jira notifications
      // JiraNotificatinsThisMonth: 0,
      // JiraNotificatinsLastMonth: 0,
      // JiraNotificatinsProgress: 0,
      // JiraNotificatinsLastupdated: null,
      // JiraNotificatinsLoading: false,

      // --- active users
      activeUsers: 0,
      activeUsersLastupdated: null,
      activeUsersloading: false,
      dataRefreshing: false,

      day_by_day_activities: [],
      productwise_activity: [],

      mappedUsersCount: false,
      userOnboardingData: null,
      userOnboardingDataLoading: false,
    };
  }
  componentDidMount() {
    const { workspace, skills } = this.props;
    this.props.onRef(this);
    this.sendData();
    this.setState({ wId: this.props.match.params.wId });
    const jiraSkill = this.props.skills.find((skill) => skill.key === 'jira');
    if (this.props.skills.length > 0) {
      if (jiraSkill) {
        let isJiraConnected =
          jiraSkill &&
          jiraSkill.skill_metadata &&
          jiraSkill.skill_metadata.linked;
        this.setState({ isJiraConnected });
        // this.setState({ jiraSkill });
        this.props
          .getUserMappingAndUsers(
            this.props.match.params.wId,
            jiraSkill.skill_metadata._id,
            true
          )
          .then((res) => {
            this.setState({ mappedUsersCount: res.data.totalVerifiedAccounts });
          });
      }
    }
    // to handle the first time
    if (
      !workspace.dashboardMetrics ||
      // (workspace.dashboardMetrics &&
      //   !workspace.dashboardMetrics.hasOwnProperty('activeCheckinsCount'))
      (workspace.dashboardMetrics &&
        !workspace.dashboardMetrics.hasOwnProperty('channelsWithTroopr')) ||
      (workspace.dashboardMetrics &&
        !workspace.dashboardMetrics.hasOwnProperty('workflowActivities')) ||
      (workspace.dashboardMetrics &&
        !workspace.dashboardMetrics.hasOwnProperty('day_by_day_activities')) ||
      (workspace.dashboardMetrics &&
        !workspace.dashboardMetrics.hasOwnProperty('productwise_activity'))
    ) {
      this.getDashBoardMetrix();
    } else if (workspace.dashboardMetrics) {
      let lastUpdated = workspace.dashboardMetrics.activeUsers.lastUpdated;
      let current = moment().format();
      let start = moment(lastUpdated);
      let end = moment(current);
      let diff = end.diff(start, 'days');

      if (diff > 0) this.getDashBoardMetrix();
      else this.setDashboardMetricsToState();
    }
    // this.getChartData();

    if (
      skills.length > 0 &&
      jiraSkill &&
      jiraSkill.skill_metadata.workspace_id === this.props.match.params.wId &&
      this.props.botuser &&
      this.props.botuser._id
    ) {
      this.setStateValues();
      // this.setCheckinStateValues();
    }
  }
  componentDidUpdate(prevProps) {
    const { skills, workspace } = this.props;
    const { wId } = this.state;
    if (
      skills !== prevProps.skills &&
      skills.length > 0 &&
      this.props.botuser &&
      this.props.botuser._id
    ) {
      const jiraSkill = this.props.skills.find((skill) => skill.key === 'jira');
      if (jiraSkill) {
        let isJiraConnected =
          jiraSkill &&
          jiraSkill.skill_metadata &&
          jiraSkill.skill_metadata.linked;
        this.setState({ isJiraConnected });
        // this.setState({ jiraSkill });
        this.props
          .getUserMappingAndUsers(
            this.props.match.params.wId,
            jiraSkill.skill_metadata._id,
            true
          )
          .then((res) => {
            this.setState({ mappedUsersCount: res.data.totalVerifiedAccounts });
          });
        if (
          jiraSkill &&
          jiraSkill.skill_metadata.workspace_id === this.props.match.params.wId
        )
          this.setStateValues();
      }
    }

    // if (
    //   skills !== prevProps.skills &&
    //   skills.length > 0 &&
    //   this.props.botuser &&
    //   this.props.botuser._id
    // ) {
    //   this.setStateValues();
    // }

    if (wId != this.props.match.params.wId) {
      this.sendData();
      this.setState({ wId: this.props.match.params.wId });
      // this.getChartData();
      // to handle the first time
      if (
        !workspace.dashboardMetrics ||
        // (workspace.dashboardMetrics &&
        //   !workspace.dashboardMetrics.activeCheckinsCount)
        (workspace.dashboardMetrics &&
          !workspace.dashboardMetrics.hasOwnProperty('channelsWithTroopr')) ||
        (workspace.dashboardMetrics &&
          !workspace.dashboardMetrics.hasOwnProperty('workflowActivities')) ||
        (workspace.dashboardMetrics &&
          !workspace.dashboardMetrics.hasOwnProperty(
            'day_by_day_activities'
          )) ||
        (workspace.dashboardMetrics &&
          !workspace.dashboardMetrics.hasOwnProperty('productwise_activity'))
      ) {
        this.getDashBoardMetrix();
      } else if (workspace.dashboardMetrics) {
        // this.setDashboardMetricsToState();

        let lastUpdated = workspace.dashboardMetrics.activeUsers.lastUpdated;
        let current = moment().format();
        let start = moment(lastUpdated);
        let end = moment(current);
        let diff = end.diff(start, 'days');

        if (diff > 0) this.getDashBoardMetrix();
        else this.setDashboardMetricsToState();
      }
    }
  }

  setStateValues = () => {
    const { skills } = this.props;
    this.setState({
      userOnboardingDataLoading: true,
    });
    getUserOnboarding({
      wId: this.props.match.params.wId,
      user_id: this.props.botuser._id,
    }).then((res) => {
      if (res.data.success)
        this.setState({
          userOnboardingData: res.data.userOnboardingData,
          userOnboardingDataLoading: false,
        });
    });
    // var UserId = localStorage.trooprUserId;

    const wiki = skills.find((skill) => skill.key === 'wiki');
    const jiraSkill = skills.find((skill) => skill.key === 'jira');

    const jiraProject = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_software'
    );
    const jiraReport = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_reports'
    );
    const jiraHelpdesk = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_service_desk'
    );
    const checkinSkill = skills.find((skill) => skill.key === 'standups');

    this.setState({
      jiraSkill: jiraSkill,
      wikiSkill: wiki,
      project: jiraProject,
      helpdesk: jiraHelpdesk,
      report: jiraReport,
      checkinSkill: checkinSkill,
    });
  };

  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  sendData() {
    setTimeout(() => {
      this.props.sendData([
        moment(this.state.UserActivityLastupdated).format('lll'),
        'workspace',
      ]);
    }, 0); //calling the function when js event loop is done with other task in the callback queue
  }

  getChartData = () => {
    return new Promise((resolve, reject) => {
      getWorkspaceDashboardChartData(this.props.match.params.wId).then(
        (res) => {
          if (res.success)
            this.setState(
              {
                day_by_day_activities: res.data,
                productwise_activity: res.productwise_activity,
              },
              () => resolve(true)
            );
        }
      );
    });
  };
  getDashBoardMetrix = () => {
    Promise.all([
      this.userActivity_DashboardMetrics(),
      this.activeUsers_DasboardMetrics(),
      this.getChartData(),
    ]).then((data) => {
      this.updateWorkspaceWithMetrics('all');
      this.setState({ dataRefreshing: false });
    });

    /* *************  OLD LOGIC WITH REFRESH BUTTON  ************* */
    // let diff = 11; /* fail safe */
    // if (!isFirstTime) {
    // ----checking the seconds (we are updating all the four metrics at the same time, so only taking the time from one)
    // const start = moment(this.state.UserActivityLastupdated);
    // const end = moment(Date.now());
    // diff = end.diff(start, 'seconds');
    // }
    /*
    if(isFirstTime || diff > 9){
      this.setState({UserActivityLoading:true,CheckInSubmissionsLoading:true,JiraNotificatinsLoading:true,activeUsersloading:true})
      // -------- metrics ---------
      Promise.all([
        // -------- user activity
        this.userActivity_DashboardMetrics(),
        
        // ------- Checkin activities
        this.checkInActivities_DashboardMetrics(),
        
        // ----- Jira Notifications
        this.jiraNotifications_DashboardMetrics(),
        
        // ---- active users
        this.activeUsers_DasboardMetrics(),
      ]).then((data) => {
        this.updateWorkspaceWithMetrics("all");
      });
    }
    */

    // if ((isFirstTime/*  || diff > 9 */) && this.state.isJiraConnected) {
    //   this.setState({ dataRefreshing: true });
    //   //  this.setState({ UserActivityLoading: true, CheckInSubmissionsLoading: true, JiraNotificatinsLoading: true, activeUsersloading: true });
    //   // -------- metrics ---------
    //   Promise.all([
    //     // -------- user activity
    //     this.userActivity_DashboardMetrics(isFirstTime),

    //     // ------- Checkin activities
    //     // this.checkInActivities_DashboardMetrics(isFirstTime),

    //     // ----- Jira Notifications
    //     // this.jiraNotifications_DashboardMetrics(isFirstTime),

    //     // ---- active users
    //     this.activeUsers_DasboardMetrics(isFirstTime),
    //   ]).then((data) => {
    //     this.updateWorkspaceWithMetrics('all');
    //     // message.success({ content: 'Metrics updated successfully' });
    //     this.setState({ dataRefreshing: false });
    //   });
    // } else if ((isFirstTime/*  || diff > 9 */) && !this.state.isJiraConnected) {
    //   // this.setState({ UserActivityLoading: true, CheckInSubmissionsLoading: true, activeUsersloading: true });
    //   // -------- metrics ---------
    //   Promise.all([
    //     // -------- user activity
    //     this.userActivity_DashboardMetrics(isFirstTime),

    //     // ------- Checkin activities
    //     // this.checkInActivities_DashboardMetrics(isFirstTime),

    //     // ----- Jira Notifications
    //     // this.jiraNotifications_DashboardMetrics(isFirstTime),

    //     // ---- active users
    //     this.activeUsers_DasboardMetrics(isFirstTime),
    //   ]).then((data) => {
    //     this.updateWorkspaceWithMetrics('all');
    //     this.setState({ dataRefreshing: false });
    //   });
    // } else {
    //   // message.warning({ content: `wait for ${10 - diff} seconds` });
    // }
  };
  userActivity_DashboardMetrics = () => {
    this.setState({ UserActivityLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .getWorkspaceActivityLog(this.props.match.params.wId)
        .then((res) => {
          this.setState({ UserActivityLoading: false });
          if (res.data.success) {
            // !isFirstTime && message.success({ content: "User activities updated", key: "user_activity" });
            const data = res.data;
            this.setState(
              {
                // UserActivityThisMonth: data.ThisMonthActivity,
                // UserActivityLastMonth: data.LastMonthActivity,
                // UserActivityProgress: data.Progress,
                UserActivityLastupdated: Date.now(),
                channelsWithTroopr: data.channelsWithTroopr,
                workflowActivities: data.workflowActivities,
              },
              () => resolve(true)
            );
            this.sendData();
          }
        });
    });
  };
  // checkInActivities_DashboardMetrics = (isFirstTime) => {
  //   this.setState({ CheckInSubmissionsLoading: true });
  //   return new Promise((resolve, reject) => {
  //     this.props
  //       .getWorkspaceCkecInActivies(this.props.match.params.wId)
  //       .then((res) => {
  //         this.setState({ CheckInSubmissionsLoading: false });
  //         if (res.data.success) {
  //           // !isFirstTime && message.success({ content: "Check-in submissions updated", key: "check_submission" });
  //           const data = res.data;
  //           this.setState(
  //             {
  //               CheckInSubmissionsThisMonth: data.ThisMonthCheckInSubmissions,
  //               CheckInSubmissionsLastMonth: data.LastMonthCheckInSubmissions,
  //               activeCheckinsCount: data.activeCheckinsCount,
  //               CheckInSubmissionsLastupdated: Date.now(),
  //             },
  //             () => resolve(true)
  //           );
  //         }
  //       });
  //   });
  // };

  // jiraNotifications_DashboardMetrics = (isFirstTime) => {
  //   this.setState({ JiraNotificatinsLoading: true });
  //   return new Promise((resolve, reject) => {
  //     this.props
  //       .getWorkspaceJiraNotificationsLog(this.props.match.params.wId)
  //       .then((res) => {
  //         this.setState({ JiraNotificatinsLoading: false });
  //         if (res.data.success) {
  //           // !isFirstTime && message.success({ content: "Jira Notifications updated", key: "jira_notifications" });
  //           const data = res.data;
  //           this.setState(
  //             {
  //               JiraNotificatinsThisMonth: data.ThisMonthJiraActivity,
  //               JiraNotificatinsLastMonth: data.LastMonthJiraActivity,
  //               JiraNotificatinsProgress: data.JiraProgress,
  //               JiraNotificatinsLastupdated: Date.now(),
  //             },
  //             () => resolve(true)
  //           );
  //         }
  //       });
  //   });
  // };

  activeUsers_DasboardMetrics = (isFirstTime) => {
    this.setState({ activeUsersloading: true });
    return new Promise((resolve, reject) => {
      this.props
        .getWorkspaceActiveUsers(this.props.match.params.wId)
        .then((res) => {
          this.setState({ activeUsersloading: false });
          if (res.data.success) {
            // !isFirstTime && message.success({ content: "Active Users updated", key: "activie users" });
            this.setState(
              {
                activeUsers: res.data.uniqueArray.length,
                activeUsersLastupdated: Date.now(),
              },
              () => resolve(true)
            );
          }
        });
    });
  };

  updateWorkspaceWithMetrics = (update) => {
    const { updateWorkspace } = this.props;
    const {
      // UserActivityThisMonth,
      // UserActivityLastMonth,
      // UserActivityProgress,
      // UserActivityLoading,
      // CheckInSubmissionsThisMonth,
      // CheckInSubmissionsLastMonth,
      // JiraNotificatinsThisMonth,
      // JiraNotificatinsLastMonth,
      // JiraNotificatinsProgress,
      activeUsers,
      // activeCheckinsCount,
      channelsWithTroopr,
      workflowActivities,
      productwise_activity,
      day_by_day_activities,
    } = this.state;

    let data = {};

    if (update === 'all') {
      data = {
        dashboardMetrics: {
          // userActivity: {
          //   thisMonth: UserActivityThisMonth,
          //   lastMonth: UserActivityLastMonth,
          //   progress: UserActivityProgress,
          //   lastUpdated: Date.now(),
          // },
          // checkInSubmissions: {
          //   thisMonth: CheckInSubmissionsThisMonth,
          //   lastMonth: CheckInSubmissionsLastMonth,
          //   lastUpdated: Date.now(),
          // },
          // jiraNotifications: {
          //   thisMonth: JiraNotificatinsThisMonth,
          //   lastMonth: JiraNotificatinsLastMonth,
          //   progress: JiraNotificatinsProgress,
          //   lastUpdated: Date.now(),
          // },
          activeUsers: {
            thisMonth: activeUsers,
            lastUpdated: Date.now(),
          },
          // activeCheckinsCount,
          channelsWithTroopr,
          workflowActivities,
          day_by_day_activities,
          productwise_activity,
        },
      };
    }
    // else if(update === 'active_users'){
    //   data = {
    //     [`dashboardMetrics.activeUsers`]: {
    //       thisMonth: activeUsers,
    //       lastUpdated: Date.now(),
    //     },
    //   };
    // }
    // else if (update === 'user_activity'){
    //   data = {
    //     [`dashboardMetrics.userActivity`]: {
    //       thisMonth: UserActivityThisMonth,
    //       lastMonth: UserActivityLastMonth,
    //       progress: UserActivityProgress,
    //       lastUpdated: Date.now(),
    //     },
    //   };
    // }else if (update === 'checkin_submissions') {
    //   data = {
    //     [`dashboardMetrics.checkInSubmissions`]: {
    //       thisMonth: CheckInSubmissionsThisMonth,
    //       lastMonth: CheckInSubmissionsLastMonth,
    //       lastUpdated: Date.now(),
    //     },
    //   };
    // }else if(update === 'jira_notifications'){
    //   data = {
    //     [`dashboardMetrics.jiraNotifications`]: {
    //       thisMonth : JiraNotificatinsThisMonth,
    //       lastMonth : JiraNotificatinsLastMonth,
    //       progress : JiraNotificatinsProgress,
    //       lastUpdated : Date.now()
    //     }
    //   }
    // }

    this.props
      .updateWorkspace(this.props.match.params.wId, '', data)
      .then((res) => {
        // if (res.data.success)
        message.success({ content: 'Metrics updated successfully' });
      });
  };

  setDashboardMetricsToState = () => {
    const { workspace } = this.props;
    const userActivity = workspace.dashboardMetrics.userActivity;
    const checkInSubmissions = workspace.dashboardMetrics.checkInSubmissions;
    const jiraNotifications = workspace.dashboardMetrics.jiraNotifications;
    const activeUsers = workspace.dashboardMetrics.activeUsers;
    this.setState({
      // UserActivityThisMonth: userActivity.thisMonth,
      // UserActivityLastMonth: userActivity.lastMonth,
      // UserActivityProgress: userActivity.progress,
      UserActivityLastupdated: activeUsers.lastUpdated,
      // CheckInSubmissionsThisMonth: checkInSubmissions.thisMonth,
      // CheckInSubmissionsLastMonth: checkInSubmissions.lastMonth,
      // CheckInSubmissionsLastupdated: checkInSubmissions.lastUpdated,
      // JiraNotificatinsThisMonth: jiraNotifications.thisMonth,
      // JiraNotificatinsLastMonth: jiraNotifications.lastMonth,
      // JiraNotificatinsProgress: jiraNotifications.progress,
      // JiraNotificatinsLastupdated: jiraNotifications.lastUpdated,
      activeUsers: activeUsers.thisMonth,
      activeUsersLastupdated: activeUsers.lastUpdated,
      // activeCheckinsCount: workspace.dashboardMetrics.activeCheckinsCount || 0,
      channelsWithTroopr: workspace.dashboardMetrics.channelsWithTroopr || 0,
      workflowActivities: workspace.dashboardMetrics.workflowActivities || 0,
      day_by_day_activities:
        workspace.dashboardMetrics.day_by_day_activities || [],
      productwise_activity:
        workspace.dashboardMetrics.productwise_activity || [],
    });
  };

  getProgressPercent = () => {
    const { jiraSkill } = this.state;

    const wikiSkill = this.props.skills.find((skill) => skill.key === 'wiki');
    const checkinSkill = this.props.skills.find(
      (skill) => skill.key === 'standups'
    );

    const helpdeskSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_service_desk'
      );

    const projectSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_software'
      );

    const reportSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_reports'
      );

    let enabledProductsCount = 0;
    let totalPercentage = 0;

    if (
      checkinSkill &&
      checkinSkill.skill_metadata &&
      !checkinSkill.skill_metadata.disabled
    ) {
      totalPercentage += this.checkinPercentage();
      enabledProductsCount++;
    }
    if (
      wikiSkill &&
      wikiSkill.skill_metadata &&
      !wikiSkill.skill_metadata.disabled
    ) {
      totalPercentage += this.wikiPercentage();
      enabledProductsCount++;
    }

    if (helpdeskSubSkill && !helpdeskSubSkill.disabled) {
      enabledProductsCount++;
      totalPercentage += this.helpdeskPercentage();
    }

    if (reportSubSkill && !reportSubSkill.disabled) {
      enabledProductsCount++;
      totalPercentage += this.reportPercentage();
    }
    if (projectSubSkill && !projectSubSkill.disabled) {
      enabledProductsCount++;
      totalPercentage += this.projectPercentage();
    }

    return Math.round(totalPercentage / enabledProductsCount);

    // const checkinPercentage = this.checkinPercentage();
    // const projectPercentage = this.projectPercentage();
    // const helpdeskPercentage = this.helpdeskPercentage();
    // const wikiPercentage = this.wikiPercentage();
    // const reportPercentage = this.reportPercentage();
    // return (
    //   (checkinPercentage +
    //     projectPercentage +
    //     helpdeskPercentage +
    //     wikiPercentage +
    //     reportPercentage) /
    //   5
    // );
  };

  checkWorkspaceLevelStepStatus = ({ product, stepKey }) => {
    const { jiraSkill, wikiSkill, checkinSkill } = this.state;
    let status = false;

    const isJiraConnected =
      jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked;
    const isWikiConnected =
      wikiSkill && wikiSkill.skill_metadata && wikiSkill.skill_metadata.linked;

    if (product === 'helpdesk' && stepKey === 'connect_to_jsm')
      status = isJiraConnected;
    else if (product === 'reports' && stepKey === 'connect_to_jira')
      status = isJiraConnected;
    else if (product === 'projects' && stepKey === 'connect_to_jira')
      status = isJiraConnected;
    else if (product === 'wiki' && stepKey === 'connect_to_confluence')
      status = isWikiConnected;

    return status;
  };

  checkinPercentage = () => {
    const { userOnboardingData } = this.state;

    let checkinPercentage = 0;

    if (userOnboardingData && userOnboardingData.checkins) {
      const {
        setup_standup_checkin,
        submit_standup_answer,
        integrate_with_jira,
        unfurl_jira_issue_mentions,
      } = userOnboardingData.checkins;
      if (
        setup_standup_checkin &&
        submit_standup_answer &&
        integrate_with_jira &&
        unfurl_jira_issue_mentions
      )
        checkinPercentage = 100;
      else {
        if (setup_standup_checkin) checkinPercentage += 25;
        if (submit_standup_answer) checkinPercentage += 25;
        if (integrate_with_jira) checkinPercentage += 25;
        if (unfurl_jira_issue_mentions) checkinPercentage += 25;
      }
    }

    return checkinPercentage;
  };

  projectPercentage = () => {
    const { userOnboardingData } = this.state;

    let projectPercentage = 0;
    if (userOnboardingData && userOnboardingData.projects) {
      const {
        setup_demo_project_channel,
        issue_card_customization,
        customize_personal_notification,
        customize_creation_form,
        commands,
        emoji_actions,
      } = userOnboardingData.projects;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'projects',
          stepKey: 'connect_to_jira',
        }) &&
        setup_demo_project_channel &&
        issue_card_customization &&
        customize_personal_notification &&
        customize_creation_form &&
        commands &&
        emoji_actions
      ) {
        projectPercentage = 100;
      } else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'projects',
            stepKey: 'connect_to_jira',
          })
        )
          projectPercentage += 15;
        if (setup_demo_project_channel) projectPercentage += 15;
        if (issue_card_customization) projectPercentage += 15;
        if (customize_personal_notification) projectPercentage += 15;
        if (customize_creation_form) projectPercentage += 15;
        if (commands) projectPercentage += 15;
        if (emoji_actions) projectPercentage += 15;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'projects',
          stepKey: 'connect_to_jira',
        })
      )
        projectPercentage += 15;
    }

    return projectPercentage;
  };

  helpdeskPercentage = () => {
    const { userOnboardingData } = this.state;

    let helpdeskPercentage = 0;
    if (userOnboardingData && userOnboardingData.helpdesk) {
      const {
        setup_demo_channels,
        customize_support_channel,
        customize_agent_channel,
        manage_approvals,
        manage_private_requests,
      } = userOnboardingData.helpdesk;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'helpdesk',
          stepKey: 'connect_to_jsm',
        }) &&
        setup_demo_channels &&
        customize_support_channel &&
        customize_agent_channel &&
        manage_approvals &&
        manage_private_requests
      ) {
        helpdeskPercentage = 100;
      } else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'helpdesk',
            stepKey: 'connect_to_jsm',
          })
        )
          helpdeskPercentage += 17;
        if (setup_demo_channels) helpdeskPercentage += 17;
        if (customize_support_channel) helpdeskPercentage += 17;
        if (customize_agent_channel) helpdeskPercentage += 16;
        if (manage_approvals) helpdeskPercentage += 16;
        if (manage_private_requests) helpdeskPercentage += 16;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'helpdesk',
          stepKey: 'connect_to_jsm',
        })
      )
        helpdeskPercentage += 16.5;
    }
    return helpdeskPercentage;
    // this.setState({ helpdeskPercentage });
  };

  wikiPercentage = () => {
    const { userOnboardingData } = this.state;

    let wikiPercentage = 0;

    if (userOnboardingData && userOnboardingData.wiki) {
      const {
        setup_demo_wiki_channel,
        add_to_confluence,
        search_an_article_privately,
      } = userOnboardingData.wiki;

      if (
        this.checkWorkspaceLevelStepStatus({
          stepKey: 'connect_to_confluence',
          product: 'wiki',
        }) &&
        setup_demo_wiki_channel &&
        add_to_confluence &&
        search_an_article_privately
      )
        wikiPercentage = 100;
      else {
        if (
          this.checkWorkspaceLevelStepStatus({
            stepKey: 'connect_to_confluence',
            product: 'wiki',
          })
        )
          wikiPercentage += 25;
        if (setup_demo_wiki_channel) wikiPercentage += 25;
        if (add_to_confluence) wikiPercentage += 25;
        if (search_an_article_privately) wikiPercentage += 25;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          stepKey: 'connect_to_confluence',
          product: 'wiki',
        })
      )
        wikiPercentage += 25;
    }

    return wikiPercentage;
  };

  reportPercentage = () => {
    const { userOnboardingData } = this.state;

    let reportPercentage = 0;
    if (userOnboardingData && userOnboardingData.reports) {
      const {
        setup_chart_report,
        setup_issue_list_report,
        setup_custom_report,
        setup_personal_report,
      } = userOnboardingData.reports;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'reports',
          stepKey: 'connect_to_jira',
        }) &&
        setup_chart_report &&
        setup_issue_list_report &&
        setup_custom_report &&
        setup_personal_report
      )
        reportPercentage = 100;
      else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'reports',
            stepKey: 'connect_to_jira',
          })
        )
          reportPercentage += 20;
        if (setup_chart_report) reportPercentage += 20;
        if (setup_issue_list_report) reportPercentage += 20;
        if (setup_custom_report) reportPercentage += 20;
        if (setup_personal_report) reportPercentage += 20;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'reports',
          stepKey: 'connect_to_jira',
        })
      )
        reportPercentage += 20;
    }
    return reportPercentage;
  };

  toggleNewStandupModal = () => {
    this.setState(
      { newStandupModalVisible: !this.state.newStandupModalVisible },
      () => {
        !this.state.newStandupModalVisible &&
          setTimeout(() => this.clickChild(), 500);
      }
    );
  };

  handleSecondaryProductCardButtonClick = (
    product,
    isSkillEnabled,
    isSkillOnboarded,
    sub_skill
  ) => {
    const { isWorkspaceAdmin, updateSkill, updateWorkspace } = this.props;
    const { jiraSkill } = this.state;
    const wikiSkill = this.props.skills.find((skill) => skill.key === 'wiki');
    const checkInSkill = this.props.skills.find(
      (skill) => skill.key === 'standups'
    );

    if (isSkillEnabled && !isSkillOnboarded) {
      if (
        product === 'jiraprojects' ||
        product === 'helpdesk' ||
        product === 'jirareports'
      ) {
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata && jiraSkill.skill_metadata._id
          }/${sub_skill.key}?view=connection`
        );
      } else if (product === 'wiki') {
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${wikiSkill.skill_metadata && wikiSkill.skill_metadata._id
          }?view=connection`
        );
      } /* else if (product === 'checkin') {
        this.toggleNewStandupModal();
      } */
    } else if (!isSkillEnabled) {
      if (isWorkspaceAdmin) {
        // this.props.history.push(`/${this.props.match.params.wId}/settings?view=product`);
        let title = '',
          content = '';

        if (
          product === 'jiraprojects' ||
          product === 'helpdesk' ||
          product === 'jirareports'
        ) {
          title = 'Enable Jira?';
          // content = `This action will activate Troopr Project/Report/HelpDesk and let you connect to Jira if not already connected.`
          content =
            product === 'jiraprojects'
              ? 'This action will activate Projects and let you connect to Jira if not already connected.'
              : `This action will activate ${jiraSkill &&
                jiraSkill.skill_metadata &&
                jiraSkill.skill_metadata.disabled
                ? 'Projects, '
                : ''
              } ${product === 'helpdesk' ? 'HelpDesk' : 'Reports'}${!(
                jiraSkill &&
                jiraSkill.skill_metadata &&
                jiraSkill.skill_metadata.linked
              )
                ? ' and let you connect to Jira if not already connected.'
                : '.'
              }`;
        } else if (product === 'wiki') {
          title = 'Enable Confluence?';
          content =
            'This action will activate Wiki and let you connect to Confluence if not already connected.';
        } else if (product === 'checkin') {
          title = 'Enable Check-in';
          content = 'This action will activate Check-ins';
        }

        Modal.confirm({
          title,
          content,
          okText: 'Proceed',
          onOk: () => {
            let data = {};
            if (sub_skill) {
              if (
                product === 'jiraprojects' ||
                product === 'helpdesk' ||
                product === 'jirareports'
              ) {
                let temp = [...jiraSkill.skill_metadata.sub_skills];
                temp = temp.map((s) => {
                  if (s.key === sub_skill.key) {
                    s.disabled = !sub_skill.disabled;
                    return s;
                  } else return s;
                });
                data.sub_skills = [...temp];
                updateSkill(
                  jiraSkill.skill_metadata._id,
                  this.props.match.params.wId,
                  data
                ).then((res) => {
                  let view = 'connection';
                  if (product === 'jiraprojects' || product === 'helpdesk')
                    view = 'channel_preferences';
                  else if (product === 'jirareports') view = 'reports';
                  if (res.data.success)
                    jiraSkill &&
                      jiraSkill.skill_metadata &&
                      jiraSkill.skill_metadata.linked
                      ? this.props.history.push(
                        `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata &&
                        jiraSkill.skill_metadata._id
                        }/${sub_skill.key}?view=${view}`
                      )
                      : this.props.history.push(
                        `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata &&
                        jiraSkill.skill_metadata._id
                        }/${sub_skill.key}?view=connection`
                      );
                  else if (
                    res.data.error &&
                    res.data.error === 'not_a_workspace_admin'
                  )
                    message.error(
                      'Contact one of the workspace admins to enable/disable products'
                    );
                });
              }
            } else if (product === 'wiki') {
              updateSkill(
                wikiSkill.skill_metadata._id,
                this.props.match.params.wId,
                { disabled: false }
              ).then((res) => {
                if (res.data.success)
                  this.props.history.push(
                    `/${this.props.match.params.wId}/skills/${wikiSkill.skill_metadata && wikiSkill.skill_metadata._id
                    }?view=${wikiSkill &&
                      wikiSkill.skill_metadata &&
                      wikiSkill.skill_metadata.linked
                      ? 'channel_preferences'
                      : 'connection'
                    }`
                  );
                else if (
                  res.data.error &&
                  res.data.error === 'not_a_workspace_admin'
                )
                  message.error(
                    'Contact one of the workspace admins to enable/disable products'
                  );
              });
            } else if (product === 'checkin') {
              updateSkill(
                checkInSkill.skill_metadata._id,
                this.props.match.params.wId,
                { disabled: false }
              ).then((res) => {
                updateWorkspace(this.props.match.params.wId, '', {
                  disableCheckins: false,
                }).then((response) => {
                  if (res.data.success && response.data.success)
                    this.props.history.push(
                      // `/${this.props.match.params.wId}/teamsyncs/templates/new_checkin`
                      `/${this.props.match.params.wId}/teamsyncs`
                    );
                  else if (
                    res.data.error &&
                    res.data.error === 'not_a_workspace_admin'
                  )
                    message.error(
                      'Contact one of the workspace admins to enable/disable products'
                    );
                });
              });
            }
          },
        });
      } else {
        message.warning(this.getErrorMessgage());
      }
    } else {
      message.error('Error redirecting skill');
    }
  };

  render() {
    const { workspace, isWorkspaceAdmin } = this.props;
    const {
      UserActivityLoading,
      // UserActivityThisMonth,
      // UserActivityLastMonth,
      // UserActivityProgress,
      UserActivityLastupdated,
      // CheckInSubmissionsLoading,
      // CheckInSubmissionsThisMonth,
      // CheckInSubmissionsLastMonth,
      // CheckInSubmissionsLastupdated,
      // JiraNotificatinsLoading,
      // JiraNotificatinsThisMonth,
      // JiraNotificatinsLastMonth,
      // JiraNotificatinsProgress,
      // JiraNotificatinsLastupdated,
      activeUsersloading,
      activeUsers,
      activeUsersLastupdated,
      mappedUsersCount,
      // activeCheckinsCount,
      jiraSkill,
      channelsWithTroopr,
      workflowActivities,
      newStandupModalVisible,
    } = this.state;

    const progressPercent = this.getProgressPercent();

    const wikiSkill = this.props.skills.find((skill) => skill.key === 'wiki');
    const checkinSkill = this.props.skills.find(
      (skill) => skill.key === 'standups'
    );

    const helpdeskSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_service_desk'
      );

    const projectSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_software'
      );

    const reportSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_reports'
      );

    const buttonStyle = {
      position: 'absolute',
      bottom: '8%',
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'left',
      paddingLeft: '23px',
    };

    let userName = '';

    if (this.props.user_now._id && this.props.botuser._id) {
      userName =
        this.props.botuser.displayName ||
        this.props.botuser.name ||
        this.props.user_now.displayName ||
        this.props.user_now.name;
    }

    return (
      <>
        <Row gutter={[24, 24]}>
          <Col className='gutter-row' span={15}>
            <Card
              title='Active Users'
              size='small'
              headStyle={{ display: 'none' }}
              style={{ height: '100%' }}
              bodyStyle={{ padding: '39.5px 24px' }}
            >
              <Row gutter={[60, 0]}>
                <Col span={15}>
                  <div style={{ marginBottom: '16px' }}>
                    <Title level={5} style={{ fontWeight: 'normal' }}>
                      Hey {userName}, welcome to Troopr{' '}
                    </Title>
                    <Text type='secondary'>
                      Troopr is your AI copilot for project management. Offload
                      the manual and tedious parts of project management to
                      Troopr.
                    </Text>
                  </div>
                  <div>
                    <Button
                      type='primary'
                      target='_blank'
                      href='https://youtu.be/Acdzh7176sc'
                      style={{ marginRight: 5 }}
                    >
                      Watch Video
                    </Button>

                    {/* </div>
                  <div> */}
                    <Button
                      target='_blank'
                      href='https://calendly.com/troopr/demo'
                      type='text'
                    >
                      Book a demo
                    </Button>
                    <Button
                      target='_blank'
                      href='https://docs.troopr.ai/'
                      type='text'
                    >
                      Read Docs
                    </Button>
                  </div>
                </Col>
                <Col
                  span={9}
                  style={{
                    display: 'grid',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img src={Welcome_to_troopr_card_svg}></img>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col className='gutter-row' span={9}>
            <Card
              size='small'
              style={{ height: '100%' }}
              headStyle={{ display: 'none' }}
              bodyStyle={{ padding: '24px' }}
              loading={this.state.userOnboardingDataLoading}
            >
              {progressPercent === 100 ? (
                <div
                  style={{
                    textAlign: 'center',
                  }} /* style={{ display : 'flex', textAlign:'center', justifyContent : 'center', flexFlow:'column', alignItems : 'center'}} */
                >
                  <div style={{ marginBottom: '8px' }}>
                    <img src={CheckCircleIcon}></img>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <Title level={5}>
                      Congratulations onboarding is
                      <br />
                      completed 🥳
                    </Title>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <Text type='secondary'>
                      Check out our documentation to learn more
                      <br />
                      about Troopr.
                    </Text>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <Button
                      style={{ width: '100%' }}
                      target='_blank'
                      href='https://docs.troopr.ai'
                    >
                      Go to docs
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <Title level={5} style={{ fontWeight: 'normal' }}>
                    Get Started with Troopr
                  </Title>
                  <Text type='secondary'>
                    {progressPercent && progressPercent === 100
                      ? 'Done'
                      : 'In progress'}
                  </Text>
                  <div style={{ marginBottom: '8px' }}>
                    <Progress
                      percent={progressPercent}
                      strokeColor={
                        progressPercent && progressPercent === 100
                          ? ''
                          : localStorage.getItem('theme') === 'dark'
                            ? '#664af0'
                            : '#402E96'
                      }
                    />
                  </div>
                  <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                    <Text strong>Estimated Time</Text>
                    <br />
                    <Text type='secondary'>5-10 Minutes</Text>
                  </div>
                  <div>
                    <Button
                      style={{ width: '100%' }}
                      type='primary'
                      onClick={() =>
                        this.props.history.push(
                          `/${this.props.match.params.wId}/getting_started`
                        )
                      }
                    >
                      View Details
                    </Button>
                  </div>
                </>
              )}
            </Card>
          </Col>
          <Col className='gutter-row' span={24}>
            <Title level={4} style={{ fontWeight: 'normal' }}>
              Troopr products
            </Title>
            <Card
              size='small'
              headStyle={{ display: 'none' }}
              bodyStyle={{ padding: '24px' }}
            >
              <Row gutter={[16, 0]}>
                {helpdeskSubSkill && (
                  <Col /* span={4} */ style={{ width: '20%' }}>
                    <Card
                      size='small'
                      headStyle={{ display: 'none' }}
                      style={{
                        height: '100%',
                        background:
                          localStorage.getItem('theme') === 'dark'
                            ? '#16B1B840'
                            : '#E4FBFB',
                      }}
                      bodyStyle={{ padding: '0px' }}
                    >
                      <div style={{ padding: '16px' }}>
                        <div style={{ marginBottom: '60px' }}>
                          <div style={{ marginBottom: '16px' }}>
                            <img src={HelpdeskIcon}></img>
                          </div>
                          <div>
                            <Title level={5} style={{ fontWeight: 'normal' }}>
                              HelpDesk
                            </Title>
                          </div>
                          <Text type='secondary'>
                            Manage Jira service requests in Slack
                          </Text>
                        </div>
                      </div>

                      {helpdeskSubSkill && helpdeskSubSkill.disabled ? (
                        <Button
                          type='text'
                          style={buttonStyle}
                          onClick={() =>
                            this.handleSecondaryProductCardButtonClick(
                              'helpdesk',
                              helpdeskSubSkill && helpdeskSubSkill.disabled
                                ? false
                                : true,
                              this.state.isJiraConnected,
                              helpdeskSubSkill
                            )
                          }
                        >
                          Enable HelpDesk <ArrowRightOutlined />
                        </Button>
                      ) : (
                        <Button
                          type='text'
                          style={buttonStyle}
                          onClick={() =>
                            this.props.history.push(
                              `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_service_desk`
                            )
                          }
                        >
                          Go to HelpDesk <ArrowRightOutlined />
                        </Button>
                      )}
                    </Card>
                  </Col>
                )}
                {wikiSkill && wikiSkill.skill_metadata && (
                  <Col /* span={4} */ style={{ width: '20%' }}>
                    <Card
                      size='small'
                      headStyle={{ display: 'none' }}
                      style={{
                        height: '100%',
                        background:
                          localStorage.getItem('theme') === 'dark'
                            ? '#59BC4A40'
                            : '#F5FBF4',
                      }}
                      bodyStyle={{ padding: '0px' }}
                    >
                      <div style={{ padding: '16px' }}>
                        <div style={{ marginBottom: '60px' }}>
                          <div style={{ marginBottom: '16px' }}>
                            <img src={WikiIcon}></img>
                          </div>
                          <div>
                            <Title level={5} style={{ fontWeight: 'normal' }}>
                              Wiki
                            </Title>
                          </div>
                          <Text type='secondary'>
                            Answer with Confluence articles in Slack
                          </Text>
                        </div>
                      </div>

                      {wikiSkill.skill_metadata.disabled ? (
                        <Button
                          type='text'
                          style={buttonStyle}
                          onClick={() =>
                            this.handleSecondaryProductCardButtonClick(
                              'wiki',
                              wikiSkill.skill_metadata.disabled ? false : true,
                              wikiSkill.skill_metadata.linked
                            )
                          }
                        >
                          Enable Wiki <ArrowRightOutlined />
                        </Button>
                      ) : (
                        <Button
                          type='text'
                          style={buttonStyle}
                          onClick={() =>
                            this.props.history.push(
                              `/${this.props.match.params.wId}/skills/${wikiSkill.skill_metadata._id}`
                            )
                          }
                        >
                          Go to Wiki <ArrowRightOutlined />
                        </Button>
                      )}
                    </Card>
                  </Col>
                )}
                <Col /* span={4} */ style={{ width: '20%' }}>
                  <Card
                    size='small'
                    headStyle={{ display: 'none' }}
                    style={{
                      height: '100%',
                      background:
                        localStorage.getItem('theme') === 'dark'
                          ? '#DD8E1740'
                          : '#FEF9F1',
                    }}
                    bodyStyle={{ padding: '0px' }}
                  >
                    <div style={{ padding: '16px' }}>
                      <div style={{ marginBottom: '60px' }}>
                        <div style={{ marginBottom: '16px' }}>
                          <img src={ProjectIcon}></img>
                        </div>
                        <div>
                          <Title level={5} style={{ fontWeight: 'normal' }}>
                            Projects
                          </Title>
                        </div>
                        <Text type='secondary'>
                          Manage Jira software issues in Slack
                        </Text>
                      </div>
                    </div>
                    {projectSubSkill && projectSubSkill.disabled ? (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.handleSecondaryProductCardButtonClick(
                            'jiraprojects',
                            projectSubSkill && projectSubSkill.disabled
                              ? false
                              : true,
                            this.state.isJiraConnected,
                            projectSubSkill
                          )
                        }
                      >
                        Enable Projects <ArrowRightOutlined />
                      </Button>
                    ) : (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.props.history.push(
                            `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software`
                          )
                        }
                      >
                        Go to Projects <ArrowRightOutlined />
                      </Button>
                    )}
                  </Card>
                </Col>
                <Col /* span={4} */ style={{ width: '20%' }}>
                  <Card
                    size='small'
                    headStyle={{ display: 'none' }}
                    style={{
                      height: '100%',
                      background:
                        localStorage.getItem('theme') === 'dark'
                          ? '#C370EB40'
                          : '#F9F2FD',
                    }}
                    bodyStyle={{ padding: '0px' }}
                  >
                    <div style={{ padding: '16px' }}>
                      <div style={{ marginBottom: '60px' }}>
                        <div style={{ marginBottom: '16px' }}>
                          <img src={ReportIcon}></img>
                        </div>
                        <div>
                          <Title level={5} style={{ fontWeight: 'normal' }}>
                            Reports
                          </Title>
                        </div>
                        <Text type='secondary'>
                          Share actionable Jira reports in Slack
                        </Text>
                      </div>
                    </div>

                    {reportSubSkill && reportSubSkill.disabled ? (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.handleSecondaryProductCardButtonClick(
                            'jirareports',
                            reportSubSkill && reportSubSkill.disabled
                              ? false
                              : true,
                            this.state.isJiraConnected,
                            reportSubSkill
                          )
                        }
                      >
                        Enable Reports <ArrowRightOutlined />
                      </Button>
                    ) : (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.props.history.push(
                            `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_reports`
                          )
                        }
                      >
                        Go to Reports <ArrowRightOutlined />
                      </Button>
                    )}
                  </Card>
                </Col>
                <Col /* span={4} */ style={{ width: '20%' }}>
                  <Card
                    size='small'
                    headStyle={{ display: 'none' }}
                    style={{
                      height: '100%',
                      background:
                        localStorage.getItem('theme') === 'dark'
                          ? '#EE4B4B40'
                          : '#FEF1F1',
                    }}
                    bodyStyle={{ padding: '0px' }}
                  >
                    <div style={{ padding: '16px' }}>
                      <div style={{ marginBottom: '60px' }}>
                        <div style={{ marginBottom: '16px' }}>
                          <img src={CheckinIcon}></img>
                        </div>
                        <div>
                          <Title level={5} style={{ fontWeight: 'normal' }}>
                            Check-ins
                          </Title>
                        </div>
                        <Text type='secondary'>
                          Conduct asynchronous meetings in Slack
                        </Text>
                      </div>
                    </div>
                    {checkinSkill && checkinSkill.skill_metadata.disabled ? (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.handleSecondaryProductCardButtonClick('checkin')
                        }
                      >
                        Enable Check-ins <ArrowRightOutlined />
                      </Button>
                    ) : (
                      <Button
                        type='text'
                        style={buttonStyle}
                        onClick={() =>
                          this.props.history.push(
                            `/${this.props.match.params.wId}/teamsyncs`
                          )
                        }
                      >
                        Go to Check-ins <ArrowRightOutlined />
                      </Button>
                    )}
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
          {isWorkspaceAdmin && (
            <Col>
              <Title level={4} style={{ fontWeight: 'normal' }}>
                Metrics
              </Title>
              <Row gutter={[24, 24]}>
                <Col className='gutter-row' span={6}>
                  <Card
                    // title='Active Users'
                    size='small'
                    headStyle={{ display: 'none' }}
                    // bordered={false}
                    style={{ height: '100%' }}
                    bodyStyle={{ padding: '24px' }}
                  // extra={
                  // <Tooltip title={`Last updated at ${moment(activeUsersLastupdated).format("lll")}. Click to reload.`}>
                  //   <Button
                  //     size='small'
                  //     type='link'
                  //     shape='circle'
                  //     onClick={() => this.getDashBoardMetrix()}
                  //     icon={<ReloadOutlined spin={activeUsersloading} />}
                  //   />
                  // </Tooltip>
                  // }
                  >
                    <Statistic
                      title={
                        <Row>
                          <Col span={19}>
                            <Title
                              level={5}
                              type='secondary'
                              style={{ fontWeight: 'normal' }}
                            >
                              Active users
                              <br />
                              (last 30 days)
                            </Title>
                          </Col>
                          <Col>
                            <img src={ActiveUsersIcon}></img>
                          </Col>
                        </Row>
                      }
                      valueStyle={{ fontSize: '30px' }}
                      value={activeUsers}
                    />
                  </Card>
                </Col>
                {/* <Col className='gutter-row' span={12}>
            <Card
              size='small'
              title='User activities'
              style={{ height: '100%' }}
              // bordered={false}
              // extra={
              // <Tooltip title={`Last updated at ${moment(UserActivityLastupdated).format("lll")}. Click to reload.`}>
              //   <Button
              //     size='small'
              //     type='link'
              //     shape='circle'
              //     onClick={() => this.getDashBoardMetrix()}
              //     icon={<ReloadOutlined spin={UserActivityLoading} />}
              //   />
              // </Tooltip>
              // }
            >
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Statistic
                    title='30 days'
                    value={UserActivityThisMonth}
                    // suffix="/ 30days"
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title='Previous period'
                    value={UserActivityLastMonth}
                    // suffix="/ 30days"
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title='Progress'
                    value={Math.abs(Math.round(UserActivityProgress))}
                    // precision={2}
                    valueStyle={{
                      color:
                        UserActivityProgress > 0 ||
                        UserActivityProgress === 0 ||
                        UserActivityProgress === null
                          ? '#3f8600'
                          : 'red',
                    }}
                    prefix={
                      UserActivityProgress > 0 ||
                      UserActivityProgress === 0 ||
                      UserActivityProgress === null ? (
                        <ArrowUpOutlined />
                      ) : (
                        <ArrowDownOutlined />
                      )
                    }
                    suffix='%'
                  />
                </Col>
              </Row>
            </Card>
          </Col> */}

                {/* {!workspace.disableCheckins && (
            <Col className='gutter-row' span={8}>
              <Card
                style={{ width: '100%', height: '100%' }}
                title='Check-in submissions'
                size='small'
                // extra={
                // <Tooltip title={`Last updated at ${moment(CheckInSubmissionsLastupdated).format("lll")}. Click to reload.`}>
                //   <Button
                //     size='small'
                //     type='link'
                //     shape='circle'
                //     onClick={() => this.getDashBoardMetrix()}
                //     icon={<ReloadOutlined spin={CheckInSubmissionsLoading} />}
                //   />
                // </Tooltip>
                // }
              >
                <Row>
                  <Col span={12}>
                    <Statistic
                      title='30 days'
                      value={CheckInSubmissionsThisMonth}
                    />
                  </Col>
                  <Col span={12}>
                    <Statistic
                      title='Previous period'
                      value={CheckInSubmissionsLastMonth}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          )} */}

                {/* {this.state.isJiraConnected &&
                jiraSkill &&
                !jiraSkill.skill_metadata.disabled && ( */}
                {jiraSkill &&
                  projectSubSkill &&
                  helpdeskSubSkill &&
                  reportSubSkill && (
                    <Col className='gutter-row' span={6}>
                      <Card
                        style={{ width: '100%', height: '100%' }}
                        headStyle={{ display: 'none' }}
                        bodyStyle={{ padding: '24px' }}
                        title='Jira verified Users'
                        size='small'
                      // extra={
                      //   <Tooltip title='Last updated 2 days ago. Click to reload.'>
                      //     <Button size='small' type='link' shape='circle' icon={<ReloadOutlined />} />
                      //   </Tooltip>
                      // }
                      >
                        <Statistic
                          // title='Jira verified Users / All workspace members'
                          title={
                            <Row>
                              <Col span={19}>
                                <Title
                                  level={5}
                                  type='secondary'
                                  style={{ fontWeight: 'normal' }}
                                >
                                  Verified Jira
                                  <br />
                                  account
                                </Title>
                              </Col>
                              <Col>
                                <img src={VerifedJiraAccountIcon}></img>
                              </Col>
                            </Row>
                          }
                          valueStyle={
                            (jiraSkill &&
                              jiraSkill.skill_metadata &&
                              jiraSkill.skill_metadata.disabled) ||
                              this.state.isJiraConnected
                              ? { fontSize: '30px' }
                              : { fontSize: '21px' }
                          }
                          value={
                            projectSubSkill.disabled &&
                              helpdeskSubSkill.disabled &&
                              reportSubSkill.disabled
                              ? 'Jira products disabled'
                              : !this.state.isJiraConnected
                                ? 'Not connected'
                                : mappedUsersCount !== false
                                  ? mappedUsersCount
                                  : '-'
                          }
                          suffix={
                            !(
                              jiraSkill &&
                              jiraSkill.skill_metadata &&
                              jiraSkill.skill_metadata.disabled
                            ) && this.state.isJiraConnected
                              ? `/ ${workspace.membershipCount}`
                              : ''
                          }
                        />
                      </Card>
                    </Col>
                  )}
                <Col className='gutter-row' span={6}>
                  <Card
                    size='small'
                    style={{ height: '100%' }}
                    headStyle={{ display: 'none' }}
                    bodyStyle={{ padding: '24px' }}
                  >
                    <Statistic
                      title={
                        <Row>
                          <Col span={19}>
                            <Title
                              level={5}
                              type='secondary'
                              style={{ fontWeight: 'normal' }}
                            >
                              Workflow activities <br />
                              (last 30 days)
                            </Title>
                          </Col>
                          <Col>
                            <img src={WorkflowActivitieIcon}></img>
                          </Col>
                        </Row>
                      }
                      valueStyle={{ fontSize: '30px' }}
                      value={workflowActivities}
                    />
                  </Card>
                </Col>
                <Col className='gutter-row' span={6}>
                  <Card
                    size='small'
                    style={{ height: '100%' }}
                    headStyle={{ display: 'none' }}
                    bodyStyle={{ padding: '24px' }}
                  >
                    <Statistic
                      title={
                        <Row>
                          <Col span={19}>
                            <Title
                              level={5}
                              type='secondary'
                              style={{ fontWeight: 'normal' }}
                            >
                              Channels with
                              <br />
                              Troopr
                            </Title>
                          </Col>
                          <Col>
                            <img src={ChannelsWithTrooprIcon}></img>
                          </Col>
                        </Row>
                      }
                      valueStyle={{ fontSize: '30px' }}
                      value={channelsWithTroopr}
                    />
                  </Card>
                </Col>

                {/* {this.state.isJiraConnected &&
            jiraSkill &&
            !jiraSkill.skill_metadata.disabled && (
              <Col className='gutter-row' span={10}>
                <Card
                  style={{ width: '100%' }}
                  title='Jira Notifications'
                  size='small'
                  // extra={
                  // <Tooltip title={`Last updated at ${moment(JiraNotificatinsLastupdated).format("lll")}. Click to reload.`}>
                  //   <Button
                  //     size='small'
                  //     type='link'
                  //     shape='circle'
                  //     onClick={() => this.getDashBoardMetrix()}
                  //     icon={<ReloadOutlined spin={JiraNotificatinsLoading} />}
                  //   />
                  // </Tooltip>
                  // }
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Statistic
                        title='30 days'
                        value={JiraNotificatinsThisMonth}
                        // suffix="/ 30days"
                      />
                    </Col>
                    <Col span={8}>
                      <Statistic
                        title='Previous period'
                        value={JiraNotificatinsLastMonth}
                        // suffix="/ 30days"
                      />
                    </Col>
                    <Col span={8}>
                      <Statistic
                        title='Progress'
                        value={Math.abs(Math.round(JiraNotificatinsProgress))}
                        // precision={2}
                        valueStyle={{
                          color:
                            JiraNotificatinsProgress > 0 ||
                            JiraNotificatinsProgress === 0 ||
                            JiraNotificatinsProgress === null
                              ? '#3f8600'
                              : 'red',
                        }}
                        prefix={
                          JiraNotificatinsProgress > 0 ||
                          JiraNotificatinsProgress === 0 ||
                          JiraNotificatinsProgress === null ? (
                            <ArrowUpOutlined />
                          ) : (
                            <ArrowDownOutlined />
                          )
                        }
                        suffix='%'
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
            )} */}
                {/* {!workspace.disableCheckins && (
            <Col className='gutter-row' span={6}>
              <Card
                title='Active Check-ins'
                size='small'
                // bordered={false}
                style={{ height: '100%' }}
                // extra={
                // <Tooltip title={`Last updated at ${moment(CheckInSubmissionsLastupdated).format("lll")}. Click to reload.`}>
                //   <Button
                //     size='small'
                //     type='link'
                //     shape='circle'
                //     onClick={() => this.getDashBoardMetrix()}
                //     icon={<ReloadOutlined spin={CheckInSubmissionsLoading} />}
                //   />
                // </Tooltip>
                // }
              >
                <Statistic value={activeCheckinsCount} />
              </Card>
            </Col>
          )} */}
                <DashboardChart
                  day_by_day_activities={this.state.day_by_day_activities}
                  productwise_activity={this.state.productwise_activity}
                />
              </Row>
            </Col>
          )}
        </Row>

        {newStandupModalVisible && (
          <CreateTeamsyncModal
            newStandupModalVisible={newStandupModalVisible}
            modalToggle={this.toggleNewStandupModal}
            // https://stackoverflow.com/questions/37949981/call-child-method-from-parent
            setClick={(click) => (this.clickChild = click)}

          //whenever you add something here check in allstandups,standupReport,sidenavbar files too
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  skills: state.skills.skills,

  workspace: state.common_reducer.workspace,
  team: state.skills.team,
  botuser: state.common_reducer.tpuser,
  isWorkspaceAdmin: state.common_reducer.isAdmin,
  user_now: state.common_reducer.user,
});

export default withRouter(
  connect(mapStateToProps, {
    getWorkspaceActivityLog,
    getWorkspaceCkecInActivies,
    getWorkspaceJiraNotificationsLog,
    getUserMappingAndUsers,
    getWorkspaceActiveUsers,
    updateWorkspace,
    updateSkill,
  })(Dashboard)
);
